import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * Plan type chip matching Plans.js design.
 * Different styles for Budget (purple), Forecast (orange), What if (teal).
 * Returns null if planType is null/undefined/empty.
 */
const PlanTypeChip = ({ planType }) => {
  if (!planType || !String(planType).trim()) return null;

  const normalized = String(planType).toLowerCase().trim().replace(/\s+/g, " ");
  const stylesMap = {
    budget: { color: "#E02DA4", bgcolor: "rgba(224, 45, 164, 0.16)" },
    forecast: { color: "#E9750F", bgcolor: "rgba(233, 117, 15, 0.16)" },
    "what if": { color: "#169FA9", bgcolor: "rgba(22, 159, 169, 0.16)" },
    whatif: { color: "#169FA9", bgcolor: "rgba(22, 159, 169, 0.16)" },
  };
  const style = stylesMap[normalized] || stylesMap[normalized.replace(/\s/g, "")];
  if (!style) return null;

  const displayLabel =
    normalized === "what if" || normalized === "whatif"
      ? "What if"
      : planType.charAt(0).toUpperCase() + planType.slice(1).toLowerCase();

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: 24,
        px: "6px",
        borderRadius: "6px",
        fontWeight: 700,
        fontSize: "12px",
        lineHeight: "20px",
        color: style.color,
        bgcolor: style.bgcolor,
      }}
    >
      <Typography
        component="span"
        sx={{
          fontWeight: 700,
          fontSize: "12px",
          lineHeight: "20px",
          color: "inherit",
        }}
      >
        {displayLabel}
      </Typography>
    </Box>
  );
};

export default PlanTypeChip;
